import { render, staticRenderFns } from "./IconTitleSection.vue?vue&type=template&id=27366613&scoped=true&"
import script from "./IconTitleSection.vue?vue&type=script&lang=js&"
export * from "./IconTitleSection.vue?vue&type=script&lang=js&"
import style0 from "./IconTitleSection.vue?vue&type=style&index=0&id=27366613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27366613",
  null
  
)

export default component.exports